<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><em>“Time is but the stream I go a-fishing in.”</em></p>
<p class="dedir">- Henry David Thoreau</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?edc68c86